import React, { FC } from "react";

import { PageSection } from "../PageSection/PageSection";

import { EditorSection } from "./EditorSection/EditorSection";
import { EditorFeature } from "./EditorFeature/EditorFeature";

import PencilIcon from "../../assets/platform/lineIcons/clapperboard.svg";
import WandIcon from "../../assets/platform/lineIcons/pallete.svg";
import TestTubeIcon from "../../assets/platform/lineIcons/chart.svg";

export const Editor: FC = () => {
	return (
		<PageSection
			id="platform"
			heading="No code editor. Just write your prompt and AI builds the game for you"
			headingType="impact"
			isVisuallyHiddenHeading={false}
		>
			<EditorSection
				icon={PencilIcon}
				heading="Beautiful games that are easy to deploy"
				lead="Beautiful games that are easy to deploy"
				videoPath="/videos/editor/adeptly_games.mp4"
			>
				<EditorFeature
					id="rapidly-build"
					text="Style and brand every game to match your organisation"
				/>
				<EditorFeature
					id="style-bran"
					text="Add player leaderboards to spark friendly competition"
				/>
				<EditorFeature
					id="simple-url"
					text="Share a simple URL and play on any device"
				/>
				<EditorFeature
					id="player-leaderboards"
					text="Embed seamlessly into your website or LMS (xAPI &amp; SCORM supported)"
				/>
			</EditorSection>
			<EditorSection
				icon={WandIcon}
				textRight={true}
				heading="Easy to use drag and drop editor"
				lead="Easy to use drag and drop editor"
				videoPath="/videos/editor/adeptly_editor.mp4"
			>
				<EditorFeature
					id="decision-tree"
					text="Upload your own images, audio, video, and animations"
				/>
				<EditorFeature
					id="generate-graphics"
					text="Generate graphics instantly with AI"
				/>
				<EditorFeature
					id="publish-share"
					text="Map out decision trees and branching scenarios visually"
				/>
				<EditorFeature
					id="translate-languages"
					text="Translate your game into multiple languages with ease"
				/>
			</EditorSection>
			<EditorSection
				icon={TestTubeIcon}
				heading="Track players in real-time and measure behaviour change"
				lead="Track players in real-time and measure behaviour change"
				videoPath="/videos/editor/adeptly_analytics.mp4"
			>
				<EditorFeature
					id="track-decisions"
					text="Monitor player decisions as they happen"
				/>
				<EditorFeature
					id="spot-bad-decisions"
					text="Identify where poor choices are being made"
				/>
				<EditorFeature
					id="behaviour-change"
					text="Customise scoring to match your learning objectives"
				/>
				<EditorFeature
					id="export-share"
					text="Export your data effortlessly or connect to your CRM/LMS"
				/>
			</EditorSection>
		</PageSection>
	);
};
